export default "__VITE_ASSET__B0UGw7mo__"